module.exports = __webpack_public_path__ + "img/services.18fff7b0.png";